import React, { useState, useEffect } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LinkPrint from "@/components/ScrollTowebprint";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import Image from "next/image";
import Link from "next/link";

import logis1 from "@/public/static/images/logis-c-01.png";
import logis2 from "@/public/static/images/logis-c-02.png";
import logis3 from "@/public/static/images/logis-c-03.png";

import logis4 from "@/public/static/images/logis-c-04.png";
import logis5 from "@/public/static/images/logis-c-05.png";
import logis6 from "@/public/static/images/logis-c-06.png";
import logis7 from "@/public/static/images/logis-c-07.png";
import logis8 from "@/public/static/images/logis-c-08.png";
import logis9 from "@/public/static/images/logis-c-09.png";
import logis10 from "@/public/static/images/logis-c-10.png";
import logis11 from "@/public/static/images/logis-c-11.png";
import logis12 from "@/public/static/images/logis-c-12.png";

import log1 from "@/public/static/images/log-01.png";
import log2 from "@/public/static/images/log-02.png";

function printing_logistics() {
  const img: any = "/static/images/s-logis.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />
      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="PRINTING & LOGISTICS"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content web-content">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-top_content">
              <div className="d-flex justify-content-center">
                <h2>Printing</h2>
              </div>
            </div>
            <div className="col-12 sv_content-inner">
              <p className="mb-2">
                ITP was founded in Kyoto as ISHIDA TAISEISHA INC. in 1916. At
                the time, "printing" was the world's most advanced information
                distribution technology. ITP has supported printing service to
                many Japanese companies including long-standing major Japanese
                department stores and Japan's largest automobile manufacturer.
              </p>
              <p className="mb-4">
                In Thailand, we had our printing factory in Ayutthaya, but we
                had to close it because a big flood damaged it in 2011. After
                many twists and turns, we have established a joint venture with
                Cyber Print Co., Ltd., a significant printing company in
                Thailand, having the big printing factory in Sinsakorn. We have
                built a wide and large printing network in Thailand and offered
                a "one-stop service for printed materials" such as offset
                printing products, labels and packages etc..
              </p>
              <p className="mb-1">
                <ArrowBackIosIcon />
                Method of printing
                <ArrowForwardIosIcon />
              </p>

              <ul>
                <li>Offset Printing</li>
                <li>Silk screen printing</li>
                <li>On-demand printing</li>
                <li>Packaging printing</li>
                <li>Label printing</li>
                <li>Hot stamping</li>
              </ul>
              <p className="mb-1">
                <ArrowBackIosIcon />
                Item
                <ArrowForwardIosIcon />
              </p>
              <p className="mb-2">
                Manuals, Packaging , Carton box, Sticker, Catalog, Leaflet,
                Magazine, Calendar, Note, Leather case
              </p>
              <p className="mb-1">
                <ArrowBackIosIcon />
                Materials
                <ArrowForwardIosIcon />
              </p>
              <p className="mb-0">
                Woodfree paper, Coated paper, Board paper, Carton paper,
                Aluminum, Leather, Plastic
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr mb-3">
              <h1 className="t-white">
                Despite the rise of digital media nowadays,
              </h1>
              <h1 className="fw-bolder t-yellow mb-2">
                Printing still has its place
                <br />
                and continues to have a strong presence in many areas
              </h1>
            </div>
          </div>

          <div className="row justify-content-md-center mt-5">
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={logis1}
                  alt="Printing"
                  className="img-fluid mx-auto"
                />
                <div className="card-body mt-3">
                  <h2 className="card-title fw-bolder t-yellow">Printing</h2>
                  <p className="t-white">
                    Printed materials such as business cards, brochures, flyers,
                    and packaging provide a tangible and memorable experience
                    for customers. These materials also convey a sense of
                    professionalism and legitimacy for the business.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={logis2}
                  alt="Advertising"
                  className="img-fluid mx-auto"
                />
                <div className="card-body mt-3">
                  <h2 className="card-title fw-bolder t-yellow">Advertising</h2>
                  <p className="t-white">
                    While digital marketing strategies can be effective,
                    physical promotional materials such as brochures, flyers,
                    and business cards create a physical connection between the
                    business and the customer as it can help to build brand
                    recognition and loyalty.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={logis3}
                  alt="Packaging"
                  className="img-fluid mx-auto"
                />
                <div className="card-body mt-3">
                  <h2 className="card-title t-yellow">Packaging</h2>
                  <p className="t-white">
                    Packaging can greatly influence customers’ buying decision
                    as it is the first thing that customers see. By
                    incorporating your company logos, colors, and messaging into
                    packaging designs, it can enhance the branding and marketing
                    efforts, increase brand recognition, and create a cohesive
                    image across all of your products.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-center web-heading-spr mb-3">
              <h1 className="t-white">
                In case you are looking for a one-stop printing service
                <br />
                We have you all set here,
              </h1>
              <h1 className="fw-bolder t-yellow mb-2">
                From printing, warehousing, to delivering right at your place
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Image
                loading="lazy"
                src={log1}
                alt="Logis Cycle"
                className="img-fluid mx-auto"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr mb-5">
              <h2 className="t-white">
                Whether you're looking to promote your business through
                printing,
                <br />
                create beautiful artwork, or print any documents or packages,
                either small or big volume,
              </h2>
              <h1 className="fw-bolder t-yellow mb-2">
                our printing services have got you covered.
              </h1>
            </div>
          </div>

          <div className="row row-cols-1 row-cols-md-2">
            <div className="col mb-4">
              <div className="card h-100 card-logis">
                <div className="card-body mt-3">
                  <h2 className="card-title text-center fw-bolder t-yellow">
                    Offset Printing
                  </h2>
                  <div className="mb-3 mx-auto w-75">
                    <Image
                      loading="lazy"
                      src={logis4}
                      alt="Offset Printing"
                      className="img-fluid mx-auto d-block"
                    />
                  </div>

                  <p className="t-white">
                    Offset printing offers a high-quality printing production at
                    a lower cost per unit, making it a cost-effective choice for
                    large print runs. It also allows for precise color matching
                    and a wide range of paper and ink options, giving businesses
                    the flexibility to create unique and eye-catching printed
                    materials.
                  </p>
                  <p className="t-white">
                    We specialize in offset printing and offer a range of
                    customization options to help you create the perfect printed
                    materials for your business.
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4">
              <div className="card h-100 card-logis">
                <div className="card-body mt-3">
                  <h2 className="card-title text-center fw-bolder t-yellow">
                    Digital Printing
                  </h2>
                  <div className="mb-3 mx-auto w-75">
                    <Image
                      loading="lazy"
                      src={logis5}
                      alt="Digital Printing"
                      className="img-fluid mx-auto d-block"
                    />
                  </div>

                  <p className="t-white">
                    Digital printing is the process of printing digital-based
                    images directly onto a variety of media substrates. There is
                    no need for a printing plate, allowing the printing process
                    to be completed faster with lower cost. It also allows
                    on-demand printing and a small production run.
                  </p>
                  <p className="t-white">
                    With digital printing, you can easily customize and
                    personalize your print materials to target specific
                    audiences and achieve a more significant impact.
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4">
              <div className="card h-100 card-logis">
                <div className="card-body mt-3">
                  <h2 className="card-title text-center fw-bolder t-yellow">
                    On-Demand Printing
                  </h2>
                  <div className="mb-3 mx-auto w-75">
                    <Image
                      loading="lazy"
                      src={logis6}
                      alt="On-Demand Printing"
                      className="img-fluid mx-auto d-block"
                    />
                  </div>

                  <p className="t-white">
                    On-demand printing offers a flexible and convenient printing
                    solution. It allows greater flexibility and customization in
                    printing needs without any excess waste, leading to cost
                    savings and a more efficient use of resources.
                  </p>
                  <p className="t-white">
                    With on-demand printing, you can respond quickly to the
                    changing market conditions and customer demands without the
                    need to wait for large print runs or shipments.
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4">
              <div className="card h-100 card-logis">
                <div className="card-body mt-3">
                  <h2 className="card-title text-center fw-bolder t-yellow">
                    Packaging & Label Printing
                  </h2>
                  <div className="mb-3 mx-auto w-75">
                    <Image
                      loading="lazy"
                      src={logis7}
                      alt="Packaging & Label Printing"
                      className="img-fluid mx-auto d-block"
                    />
                  </div>

                  <p className="t-white">
                    Let your brand stand out with our customized packaging and
                    label printing. High-quality packaging and label printing
                    can help to differentiate a product from competitors,
                    increase its perceived value, and attract potential
                    customers.
                  </p>
                  <p className="t-white">
                    Whether you need packaging and labels for food products,
                    cosmetics, or any other type of product, we have the
                    expertise and technology to create designs that will meet
                    your needs and exceed your expectations.
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4">
              <div className="card h-100 card-logis">
                <div className="card-body mt-3">
                  <h2 className="card-title text-center fw-bolder t-yellow">
                    Silk Screen Printing
                  </h2>
                  <div className="mb-3 mx-auto w-75">
                    <Image
                      loading="lazy"
                      src={logis8}
                      alt="Silk Screen Printing"
                      className="img-fluid mx-auto d-block"
                    />
                  </div>

                  <p className="t-white">
                    Silk screen printing is commonly used to produce
                    high-quality and long-lasting prints on a variety of
                    materials, including clothing, signage, and promotional
                    products. It offers vibrant and opaque colors that can
                    withstand the wear and tear of everyday use. It is also
                    highly customizable, allowing for precise placement of the
                    design and the use of a wide range of ink colors and types.
                  </p>
                  <p className="t-white">
                    We specialize in silk screen printing services that cater to
                    your unique needs and specifications.
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4">
              <div className="card h-100 card-logis">
                <div className="card-body mt-3">
                  <h2 className="card-title text-center fw-bolder t-yellow">
                    Hot Stamping
                  </h2>
                  <div className="mb-3 mx-auto w-75">
                    <Image
                      loading="lazy"
                      src={logis9}
                      alt="Hot Stamping"
                      className="img-fluid mx-auto d-block"
                    />
                  </div>

                  <p className="t-white">
                    Hot stamping is a printing process that uses heat and
                    pressure to apply a metallic or colored foil onto a surface.
                    It is commonly used to add logos, text, or designs to
                    products such as packaging, labels, and promotional
                    materials. Hot stamping provides a high-quality and durable
                    finish that can enhance the visual appeal of a product and
                    make it stand out from the competition. Additionally, it can
                    be used on a variety of materials including paper, plastic,
                    and leather.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr">
              <h1>
                With more than 20 years of our experience in supporting our
                clients in printing,
              </h1>
              <h1 className="fw-bold t-yellow">
                We know the best what you want, so that we provide you all
                relevant
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center mt-5">
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={logis10}
                  alt="Warehouse Management Service"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-yellow">
                    Warehouse
                    <br /> Management Service
                  </h2>
                  <p>
                    We provide end-to-end support, from printing inventory
                    management and order fulfillment to shipping and logistics.
                    Our expert team will work to ensure that the operation runs
                    smoothly and efficiently, so that you can focus on growing
                    your business while we take care of the rest.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={logis11}
                  alt="Assembly Service"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-yellow">Assembly Service</h2>
                  <p>
                    Our assembly service that can be tailored to meet any of
                    your specific needs includes expert assembly and
                    installation of products, efficient handling and
                    transportation of products, customized solutions for
                    specific assembly needs, quality assurance checks, and
                    timely delivery of assembled products.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={logis12}
                  alt="Just-in-time
                  Delivery Service"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-yellow">
                    Just-in-time
                    <br />
                    Delivery Service
                  </h2>
                  <p>
                    Our JIT delivery service offers a reliable and efficient
                    solution to ensure that your products are delivered to your
                    customers at the right time, every time. With our JIT
                    delivery service, you can reduce your inventory holding
                    costs, optimize your supply chain, and improve your cash
                    flow.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="black-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6 box-half sv_content">
              <div className="d-flex justify-content-center align-items-center h-100">
                <h1 className="text-center">
                  Let us execute your <br />
                  printing project,
                  <br />
                  Because{" "}
                  <span className="fw-bolder">
                    we have it <br />
                    all set for you!
                  </span>
                </h1>
              </div>
            </div>
            <div className="col-12 col-md-6 sv_content px-5">
              <Image
                loading="lazy"
                src={log2}
                alt="Let us execute your 
                  printing project,
                  Because we have it 
                  all set for you!"
                className="img-fluid mx-auto p-5"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row row-cols-1 row-cols-md-3">
            <div className="col mb-4 card-text-logis ">
              <div className="card h-100 py-5">
                <div className="card-body mt-3 text-center px-5">
                  <div className="num-y">
                    <span>1</span>
                  </div>
                  <p>
                    We have all kind of printing service that will meet any of
                    your needs
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4 card-text-logis ">
              <div className="card h-100 py-5">
                <div className="card-body mt-3 text-center px-5">
                  <div className="num-y">
                    <span>2</span>
                  </div>
                  <p>
                    With over{" "}
                    <span className="t-yellow fw-bolder">
                      two decades of experience,
                    </span>{" "}
                    our team of professionals are equipped to provide you with
                    full support in every aspect of your printing operations.
                  </p>
                </div>
              </div>
            </div>

            <div className="col mb-4 card-text-logis ">
              <div className="card h-100 py-5">
                <div className="card-body mt-3 px-5">
                  <div className="num-y">
                    <span>3</span>
                  </div>
                  <p>
                    <span className="t-yellow fw-bolder">
                      From start to success,
                    </span>{" "}
                    We are here to take care of your project with our one-stop
                    service that we offer can benefit you by
                  </p>
                  <ul className="text-left">
                    <li>Idea & Design</li>
                    <li>Printing & QC</li>
                    <li>Delivery & Assembly</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content box-half">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr">
              <h1 className="mb-0">
                Ready to start your printing project with us?
              </h1>
              <h1 className="fw-bold">Do not hesitate to contact us now!</h1>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <LinkPrint />
    </div>
  );
}

export default printing_logistics;
